module.exports = __webpack_public_path__ + "static/media/VOCABicon.5c42da80.png";